import React from 'react';
import {useStyles} from "./ShowBillingPeriodStatus.style";
import clsx from "clsx";
import {Tooltip} from "@material-ui/core";
import ShowBillingPeriodStatusProperties from "./ShowBillingPeriodStatusProperties";
import {useI18nContext} from "../../../contexts/I18nContext";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import BillingPeriodStatus from '../../../entities/BillingPeriodStatus';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';

const ShowBillingPeriodStatus: React.FC<ShowBillingPeriodStatusProperties> = ({
                                                                  status,
                                                                  className = '',
                                                                  tooltip,
                                                                  label,
                                                              }) => {
    const classes = useStyles();
    const i18n = useI18nContext();
    if (!status) return <></>

    const getIcon = () => {
        switch (status) {
            case BillingPeriodStatus.REMOVED:
                return <HighlightOffIcon/>;
            case BillingPeriodStatus.OPEN:
                return <EventRepeatIcon/>;
            case BillingPeriodStatus.BILLED:
                return <LocalAtmIcon/>;
            case BillingPeriodStatus.CLOSED:
                return <EventBusyIcon/>;
        }
    }
    const getClass = () => {
        switch (status) {
            case BillingPeriodStatus.REMOVED:
                return classes.error;
            case BillingPeriodStatus.OPEN:
                return classes.success;
            case BillingPeriodStatus.BILLED:
                return classes.success;
            case BillingPeriodStatus.CLOSED:
                return classes.pending;
        }
    }
    const getSubtitle = () => {
        switch (status) {
            case BillingPeriodStatus.BILLED:
                return 'Debitado al saldo de las agencias';
            case BillingPeriodStatus.CLOSED:
                return 'No debitado al saldo de las agencias';
            default:
                return '';
        }
    }

    return (
        <Tooltip title={tooltip || ""}>
            <div className={clsx(classes.display_field_container, className, getClass())}>
                <div className={classes.value}>
                    {getIcon()}
                    {i18n.translate(`${status}`)}
                    <small className={classes.center}>{getSubtitle()}</small>
                </div>
            </div>
        </Tooltip>
    )
}
export default ShowBillingPeriodStatus;